<script>
	/**
	 * A component for displaying loading states with an animated icon and text.
	 * This component is used to indicate various loading states such as
	 * 'submitting', 'saving', and 'loading'.
	 *
	 * @component
	 *
	 * @prop {string} type - The type of loading state which determines the text displayed.
	 *                       Possible values are 'submitting', 'saving', and 'loading'.
	 *                       Defaults to 'submitting'.
	 *
	 * @example
	 * <LoadingIndicator type="submitting" />
	 * <LoadingIndicator type="saving" />
	 * <LoadingIndicator type="loading" />
	 */

	import Icon from '@iconify/svelte';
	import { slide } from 'svelte/transition';

	import { _ } from 'svelte-i18n';

	export let type = 'submiting';
</script>

<div
	class="text-sm text-gray animate-pulse text-center font-medium flex justify-center items-center gap-2 mt-2 z-30"
	transition:slide={{ duration: 300, axis: 'y' }}
>
	<Icon icon="svg-spinners:pulse-multiple" class="text-2xl" />
	{#if type === 'submiting'}
		{$_('general.submitingForm.submiting')}
	{:else if type === 'saving'}
		{$_('general.submitingForm.saving')}
	{:else if type === 'loading'}
		{$_('general.submitingForm.loading')}
	{:else if type === 'deleting'}
		{$_('general.submitingForm.deleting')}
	{/if}
</div>
